// src/api/modules/ItemIncomeApi.js
import Methods from "../methods";

const searchIncomes = (context, idClient, payload) => {
  const {filters, page, size, sortBy = "registrationDate", direction = "desc"} = payload;
  const url = `/incomes/search/${idClient}?page=${page}&size=${size}&sortBy=${sortBy}&direction=${direction}`;
  return Methods.doPost(context, url, filters, null);
};

const saveIncome = (context, payload) => {
  const url = `/incomes/save`;
  return Methods.doPost(context, url, payload, null);
};

const saveIncomeBulk = (context, payload) => {
  const {file, data} = payload;
  const formData = new FormData();

  formData.append("file", file);
  formData.append("data", new Blob([JSON.stringify(data)], {type: "application/json"}));

  const url = `/incomes/bulk-upload`;
  return Methods.doPostMultipart(context, url, formData);
};

const cancelIncome = (context, idIncome) => {
  const url = `/incomes/${idIncome}/cancel`;
  return Methods.doPut(context, url, null);
};

export default {
  searchIncomes,
  saveIncome,
  saveIncomeBulk,
  cancelIncome
};



// WEBPACK FOOTER //
// ./src/api/modules/ItemIncomeApi.js